/* eslint-disable */
import createIcon from '../createIcon';

const IconLoading3QuartersOutlined = createIcon({
  name: 'icon-loading-3-quarters-outlined',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M521.496 64.099L512 64C264.576 64 64 264.576 64 512c0 20.504 16.622 37.125 37.125 37.125 20.504 0 37.126-16.621 37.126-37.125 0-206.416 167.333-373.75 373.749-373.75l20.502.55C730.114 149.382 885.749 313.245 885.749 512c0 206.416-167.333 373.75-373.749 373.75-20.504 0-37.125 16.62-37.125 37.125C474.875 943.378 491.496 960 512 960c247.424 0 448-200.576 448-448 0-243.771-194.977-442.83-438.504-447.901z"/>',
  width: 1024,
  height: 1024
});
export default IconLoading3QuartersOutlined;
